var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencilAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33329 3.33336H3.99996C3.64634 3.33336 3.3072 3.47384 3.05715 3.72388C2.8071 3.97393 2.66663 4.31307 2.66663 4.66669V12C2.66663 12.3536 2.8071 12.6928 3.05715 12.9428C3.3072 13.1929 3.64634 13.3334 3.99996 13.3334H11.3333C11.6869 13.3334 12.0261 13.1929 12.2761 12.9428C12.5261 12.6928 12.6666 12.3536 12.6666 12V8.66669M11.724 2.39069C11.847 2.26335 11.9941 2.16177 12.1568 2.09189C12.3194 2.02201 12.4944 1.98523 12.6714 1.98369C12.8485 1.98215 13.024 2.01589 13.1879 2.08293C13.3518 2.14997 13.5006 2.24898 13.6258 2.37417C13.751 2.49936 13.85 2.64823 13.9171 2.81209C13.9841 2.97595 14.0178 3.15152 14.0163 3.32856C14.0148 3.5056 13.978 3.68056 13.9081 3.84323C13.8382 4.0059 13.7366 4.15303 13.6093 4.27603L7.88529 10H5.99996V8.11469L11.724 2.39069Z",
    stroke: "#7B7C7F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilAlt);
export default __webpack_public_path__ + "static/media/pencil-alt.5d1125909da8edcd622577da841f5129.svg";
export { ForwardRef as ReactComponent };